import React from "react";
import Card from "./Card";
import { useEffect, useState } from "react";
import * as Realm from "realm-web";

function Cards() {
  const [cards, setCards] = useState([]);

  useEffect(() => {
    const REALM_APP_ID = process.env.REACT_APP_REALM_APP_ID;
    const app = new Realm.App({ id: REALM_APP_ID });
    const credentials = Realm.Credentials.anonymous();

    const load = async () => {
      try {
        const user = await app.logIn(credentials);
        const allCards = await user.functions.getAllCards();
        setCards(allCards);
      } catch (error) {
        console.error(error);
      }
    };
    load();
  }, []);

  return cards.map((d) => {
    return (
      <Card
        key={d._id}
        profilePic={d.profilePic}
        profileName={d.profileName}
        profileHandle={d.profileHandle}
        postDate={d.postDate}
        title={d.title}
        textContent={d.textContent}
        videoUrl={d.videoUrl}></Card>
    );
  });
}

export default Cards;
